import React, {Component} from 'react';
import {
    Dropdown, IDropdownOption,
} from "office-ui-fabric-react";
import {Dictionary} from "lodash";
import ApiService from "../ApiService";
import {IMessageBarHelper} from "../../utils/IMessageBarHelper";

interface AllocateTenantRolloverProps
{
    tenantId: string;
    academicYear: string;
    currentAgentId: string | null;
    
    availableAgentIds: string[];
    agentUserDict: Dictionary<{displayName: string,userPrincipalName: string}>
    
    disabled : boolean;
    
    apiService: ApiService;
    messageBar: IMessageBarHelper;
}

interface AllocateTenantRolloverState
{
    updatedAgentId: string | null;
    saving: boolean;
    label: "Agent" | "Saved" ,
}

export class AllocateTenantRollover extends Component<AllocateTenantRolloverProps, AllocateTenantRolloverState> {
    static displayName = AllocateTenantRollover.name;

    constructor(props: AllocateTenantRolloverProps) {
        super(props);

        this.state = {
            updatedAgentId: props.currentAgentId,
            saving: false,
            label: "Agent"
        }
    }

    async componentDidMount() {
    }

    async componentDidUpdate(prevProps: Readonly<AllocateTenantRolloverProps>, prevState: AllocateTenantRolloverState) {
    }
    
    
    onChange = async (event: any,option: IDropdownOption | undefined) => {
        
        this.setState({
            saving: true
        });
        
        try
        {
            if(option?.key === "remove")
            {
                await this.props.apiService.removeTenantRolloverAllocation(this.props.tenantId,this.props.academicYear);
                this.setState({
                    updatedAgentId: null
                });
            }
            else
            {
                await this.props.apiService.allocateTenantRollover(this.props.tenantId,this.props.academicYear,option?.data!);
                this.setState({
                    updatedAgentId: option?.data
                });
            }
    
        }
        catch (e)
        {
            this.props.messageBar.error(`Failed to allocate : ${e}`,undefined);
        }
        
        this.setState({
            saving: false,
            label: "Saved"
        });
        
    }

    render()
    {
        const options: IDropdownOption[] = this.props.availableAgentIds.map(id => {
            return {
                key: id,
                text: this.props.agentUserDict[id].displayName,
                data: id
            };
        })
        
        options.push({
            key: "remove",
            data: "remove",
            text: "Remove allocation",
        });
        
        return (
           <div onClick={(e)=> e.preventDefault()}>
               <Dropdown
                   label={this.state.saving ? "Saving " : this.state.label}
                   selectedKey={this.state.updatedAgentId}
                   placeholder="Select agent"
                   options={options}
                   onChange={this.onChange}
                   disabled={this.props.disabled || this.state.saving}
                   styles={{ dropdown: { width: 300 } }}
               />
           </div>
        );
    }
}